import { jsxs as z, jsx as d } from "react/jsx-runtime";
import { useState as F, useRef as k } from "react";
import { Frame as R } from "../Frame/Frame.js";
import { TextButton as S } from "../TextButton/TextButton.js";
import { cx as f } from "../apps/ui/styled-system/css/cx.js";
import { css as e } from "../apps/ui/styled-system/css/css.js";
import { cva as m } from "../apps/ui/styled-system/css/cva.js";
function s({
  adornments: i,
  className: r,
  disabled: t,
  invalid: a,
  onChange: o,
  removeCompletion: l = !0,
  size: n = { dialog: "medium", full: "large" },
  value: p,
  formatValue: h,
  ...b
}) {
  const u = R.useFrame(!0), x = (u == null ? void 0 : u.mode) ?? "dialog", [_, v] = F(!1), c = k(null);
  return /* @__PURE__ */ z(
    "div",
    {
      className: f(
        e({
          "&:has(input:focus-visible)": {
            outline: "2px solid var(--color-th_focus)",
            outlineOffset: -1
          },
          '&:is(div):has(input:invalid, input[aria-invalid="true"])': {
            outline: "2px solid var(--border-color-th_field-error)",
            outlineOffset: -1
          },
          backgroundColor: "var(--background-color-th_field)",
          border: "1px solid var(--border-color-th_field)",
          borderRadius: "var(--radius-th_medium)",
          color: "var(--text-color-th_field)",
          display: "inline-flex",
          position: "relative",
          width: "100%"
        }),
        m({
          variants: {
            size: {
              large: {
                "--adornment-font-size": 13,
                "--input-padding-inline": "20px",
                borderRadius: 26,
                fontSize: 18,
                height: 52
              },
              medium: {
                "--adornment-font-size": 12,
                "--input-padding-inline": "16px",
                borderRadius: 8,
                fontSize: 15,
                height: 38
              }
            }
          }
        })({
          size: typeof n == "string" ? n : n[x] ?? "medium"
        }),
        t && e({
          backgroundColor: "var(--background-color-th_disabled)",
          borderColor: "var(--border-color-th_disabled)",
          color: "var(--text-color-th_disabled)!",
          pointerEvents: "none"
        })
      ),
      children: [
        (i == null ? void 0 : i.start) && /* @__PURE__ */ d(
          g,
          {
            adornment: i.start,
            inputRef: c,
            onChange: o,
            position: "start"
          }
        ),
        /* @__PURE__ */ d(
          "input",
          {
            "aria-invalid": a ? "true" : void 0,
            autoCapitalize: l ? "off" : void 0,
            autoComplete: l ? "off" : void 0,
            autoCorrect: l ? "off" : void 0,
            className: f(
              e({
                _focus: {
                  outline: "none"
                },
                "&::placeholder": {
                  color: "var(--text-color-th_field-tertiary)"
                },
                alignItems: "center",
                background: "transparent",
                color: "inherit",
                display: "flex",
                flex: "1 1 auto",
                fontSize: "inherit",
                height: "100%",
                minWidth: 0
              }),
              !(i != null && i.start) && e({ paddingLeft: "var(--input-padding-inline)" }),
              !(i != null && i.end) && e({ paddingRight: "var(--input-padding-inline)" }),
              r
            ),
            "data-1p-ignore": l ? !0 : void 0,
            disabled: t,
            onChange: (y) => {
              o(y.target.value);
            },
            ref: c,
            spellCheck: l ? !1 : void 0,
            value: _ || !h ? p : h(p),
            ...b,
            onBlur: () => v(!1),
            onFocus: () => v(!0)
          }
        ),
        (i == null ? void 0 : i.end) && /* @__PURE__ */ d(
          g,
          {
            adornment: i.end,
            inputRef: c,
            onChange: o,
            position: "end"
          }
        )
      ]
    }
  );
}
function g({
  adornment: i,
  inputRef: r,
  onChange: t,
  position: a
}) {
  return /* @__PURE__ */ d(
    "div",
    {
      className: f(
        e({
          alignItems: "center",
          display: "flex",
          fontSize: "var(--adornment-font-size)",
          height: "100%",
          paddingInline: "var(--input-padding-inline)",
          whiteSpace: "nowrap"
        }),
        a === "start" && e({
          color: "inherit",
          paddingRight: 4
        }),
        a === "end" && e({
          color: "var(--text-color-th_field-secondary)",
          paddingLeft: 4
        })
      ),
      children: s.isAdornmentFill(i) ? /* @__PURE__ */ d(
        S,
        {
          onClick: () => {
            var o;
            t(i.value), (o = r.current) == null || o.focus();
          },
          children: i.label
        }
      ) : i
    }
  );
}
((i) => {
  function r(t) {
    return typeof t == "object" && t !== null && "type" in t && t.type === "fill";
  }
  i.isAdornmentFill = r;
})(s || (s = {}));
export {
  s as Input
};
//# sourceMappingURL=Input.js.map
